import { UserIcon } from '@heroicons/react/solid';
import React from 'react';

const LoginFormHero = ({ name }) => {
  return (
    <>
      <h2 className="text-gray-900 text-lg font-semibold title-font mb-2">
        Welcome
      </h2>
      <h2 className="text-xs text-accent-500 tracking-widest font-medium title-font mb-5">
        Enter your password
      </h2>
      <div className="relative mb-4">
        <div className="flex mb-2 items-center">
          <div className="text-gray-500 border-2 border-gray-500 rounded-full py-2 px-2 mr-3">
            <UserIcon className="h-10 w-10 text-accent-500" />
          </div>
          <div className="flex flex-col">
            <p className="leading-relaxed text-xs font-medium">Admin Account</p>
            <h6 className="text-gray-600 text-md font-medium">{name}</h6>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginFormHero;
